import React, { Fragment, useState, useEffect, useCallback } from "react";
import api from "../../services/api";
import ModalAlert from "../common/modal-alert";

function ContactEdit(props) {
  const [load, setLoad] = useState(false);
  const [user, setUser] = useState({
    name: "",
    email: "",
    phone: "",
    isActive: ""
  });
  const [modal, setModal] = useState({
    alert: "",
    classText: ""
  });

  const fetchMyAPI = useCallback(async () => {
    setLoad(true);

    const res = await api.get(`/users/${props.match.params.userId}`);

    const data = {
      name: res.data.name,
      email: res.data.email,
      phone: res.data.phone,
      isActive: res.data.UserStatusId == 1 ? true : false
    };
    console.log(
      "TCL: fetchMyAPI -> res.data.UserStatusId",
      res.data.UserStatusId
    );
    setUser(data);
    console.log("TCL: fetchMyAPI -> data", data);
    setLoad(false);
  });

  useEffect(() => {
    fetchMyAPI();
  }, []);

  const handleSubmit = async () => {
    setLoad(true);
    const data = {
      name: user.name,
      email: user.email,
      phone: user.phone !== "" ? user.phone : null,
      isActive: user.isActive == true ? 1 : 2
    };
    console.log("TCL: handleSubmit -> data", data);
    await api
      .patch(
        `/companies/${props.match.params.id}/contact/${props.match.params.userId}`,
        data
      )
      .then(result => {
        setModal({
          ...modal,
          alert: result.data.msg,
          classText: "text-success"
        });
        setLoad(false);
        document.getElementById("modal-alert").click();
      })
      .catch(err => {
        console.log(
          "TCL: handleSubmit -> err",
          err.response.data.errors[0].msg
        );
        setModal({
          ...modal,
          alert: err.response.data.errors[0].msg,
          classText: "text-danger"
        });
        setLoad(false);
      });
  };

  return (
    <Fragment>
      {/* Titulo */}
      <div className="row page-titles">
        <div className="col-md-5 col-8 align-self-center">
          <h3 className="text-themecolor">
            Editar Contato
            {load ? <i className="fa fa-spin fa-spinner" /> : null}
          </h3>
        </div>
      </div>
      <div className="row">
        {/* Botão voltar */}
        <div className="p-b-10">
          <button
            onClick={() => props.history.goBack()}
            className="btn btn-rounded btn-outline-primary"
          >
            <i className="mdi mdi-arrow-left" />
          </button>
        </div>
        <div
          className={
            user.isActive == 1
              ? "col-md-12 alert alert-success"
              : "col-md-12 alert alert-danger"
          }
        >
          <span>
            Status do contato:
            <strong> {user.isActive ? "Ativo" : "Desativado"}</strong>
          </span>
        </div>
        {/* Dados do Contato */}
        <div className="col-md-1">
          <div className="form-group">
            <h5>Id</h5>
            <span>
              {props.match.params.userId ? props.match.params.userId : null}
            </span>
          </div>
        </div>
        <div className="col-md-3">
          <h5>Nome</h5>
          <input
            type="text"
            className="form-control"
            value={user.name}
            onChange={e => setUser({ ...user, name: e.target.value })}
          />
          <i className="message-error">{}</i>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <h5>E-mail</h5>
            <input
              type="text"
              className="form-control"
              value={user.email}
              onChange={e => setUser({ ...user, email: e.target.value })}
            />
            <i className="message-error">{}</i>
          </div>
        </div>
        <div className="col-md-3">
          <div className="form-group">
            <h5>Telefone</h5>
            <input
              type="text"
              className="form-control"
              onChange={e => setUser({ ...user, phone: e.target.value })}
              value={user.phone}
            />
          </div>
        </div>
        <div className="col-md-2">
          <div className="form-group">
            <h5>Ativo</h5>
            <div className="switch">
              <label>
                <input
                  type="checkbox"
                  defaultChecked={user.isActive}
                  checked={user.isActive}
                  onChange={() =>
                    setUser({ ...user, isActive: !user.isActive })
                  }
                />
                <span className="lever" />
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12 mt-5 text-center">
          <div className="form-actions">
            <button className="btn btn-success" onClick={handleSubmit}>
              {load ? (
                <i className="fa fa-spin fa-spinner" />
              ) : (
                <i className="fa fa-edit" />
              )}
              Salvar
            </button>
          </div>
        </div>

        {modal.alert ? (
          <div className="text-center col-md-12 p-t-20">
            <div className="alert alert-success">{modal.alert}</div>
          </div>
        ) : null}
      </div>

      <ModalAlert
        classText={modal.classText}
        msg={modal.alert}
        title="Documento(s)"
        function=""
      />
    </Fragment>
  );
}

export default ContactEdit;
